<template>
  <div
    :class="`text-${qtyStyleClass}`"
  >
    {{ rangeStart!==null ? renderQty(rangeStart) : '-' }}
    <template v-if="(rangeEnd!==null) && (rangeEnd !== rangeStart)">
      -
      {{ renderQty(rangeEnd) }}
    </template>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  components: {
  },
  props: {
    product: {
      type: Object,
      default: null,
    },
  },
  setup(props) {
    const rangeStart = computed(() => {
      let num = Infinity

      if (!props.product || !props.product.products || !props.product.products.length) {
        return num
      }

      props.product.products.forEach(product => {
        if (product.has_unlimited_qty) {
          return
        }

        const qty = parseInt(product.qty, 10)
        if (qty < num) {
          num = qty
        }
      })
      return num
    })
    const rangeEnd = computed(() => {
      if (!props.product || !props.product.products || !props.product.products.length) {
        return Infinity
      }

      let num = 0
      props.product.products.forEach(product => {
        const qty = product.has_unlimited_qty ? Infinity : parseInt(product.qty, 10)
        if (qty > num) {
          num = qty
        }
      })
      return num
    })

    const qtyStyleClass = computed(() => {
      if (rangeStart.value === null) {
        return 'default'
      }

      if (rangeStart.value === 0) {
        return 'danger'
      }

      if (rangeStart.value < 5) {
        return 'warning'
      }

      return 'success'
    })

    const renderQty = qty => {
      if (qty === Infinity) {
        return '∞'
      }
      return qty
    }

    return {
      rangeStart,
      rangeEnd,
      qtyStyleClass,
      renderQty,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
